'use client';

import { useState, useEffect } from 'react';
import PromotionServer, { type PromotionData } from './PromotionServer';

// Static promotion data for now
// const STATIC_PROMOTION_DATA: PromotionData = {
//   title: 'Låt en fondrobot baserad på nobelprisvinnande forskning sköta ditt sparande med Opti.',
//   description: 'Affiliate-länk. Investeringar innebär risk och tidigare avkastning är ingen garanti för framtida resultat.',
//   image: {
//     node: {
//       sourceUrl: 'https://gray-swan-140194.hostingersite.com/wp-content/uploads/2025/12/opti-logo.png',
//       altText: 'Promotion logo',
//       mediaDetails: {
//         width: 120,
//         height: 120,
//       },
//     },
//   },
//   cta: {
//     title: 'Få 50% rabatt',
//     target: '_blank',
//     url: 'https://www.opti.se/kampanj/aktiekunskapnu',
//   },
// };

interface PromotionClientProps {
  className?: string;
  promotionData?: PromotionData | null;
  articleSlug?: string;
}

export default function PromotionClient(props: PromotionClientProps) {
  const promotionData = props.promotionData;
  const [showMobileModal, setShowMobileModal] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const dismissed = sessionStorage.getItem('promotionDismissed');
    if (dismissed === 'true') {
      setIsDismissed(true);
      return;
    }

    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = (scrollTop / docHeight) * 100;

      if (scrollPercent >= 25 && window.innerWidth < 1024 && !isDismissed) {
        setShowMobileModal(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isDismissed]);

  const handleDismiss = () => {
    setShowMobileModal(false);
    setIsDismissed(true);
    if (typeof window !== 'undefined') {
      sessionStorage.setItem('promotionDismissed', 'true');
    }
  };

  if (!promotionData) return null;

  const serverProps = {
    promotionData,
    className: props.className,
  };

  return (
    <>
      {/* Normal position (desktop and after mobile dismissal) */}
      <div className={`${isDismissed ? 'block' : 'hidden lg:block'}`}>
        <PromotionServer {...serverProps} />
      </div>

      {/* Mobile modal */}
      {showMobileModal && !isDismissed && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <div className="absolute inset-0 bg-black bg-opacity-50" onClick={handleDismiss} />

          <div className="absolute bottom-8 left-0 right-0 transform transition-transform duration-300 ease-out">
            <div className="rounded-t-lg mx-4 mb-4">
              <div className="flex justify-end p-2">
                <button
                  onClick={handleDismiss}
                  className="p-2 bg-white rounded-full text-black hover:text-gray-600 transition-colors"
                  aria-label="Close promotion"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <div className="px-4 pb-4">
                <PromotionServer {...serverProps} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
